import { render } from "./outbc.vue?vue&type=template&id=51c7d9fb&scoped=true"
import script from "./outbc.vue?vue&type=script&lang=js"
export * from "./outbc.vue?vue&type=script&lang=js"

import "./outbc.vue?vue&type=style&index=0&id=51c7d9fb&lang=less&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c7d9fb"]])

export default __exports__